<template>
  <div class="home">
    <v-select
      :items="names"
      class="d-flex d-sm-none mb-6"
      hide-details
      label="Library / ห้องสมุด"
      prepend-inner-icon="mdi-library"
      outlined
      v-model="name"
    />
    <v-autocomplete
      :items="names"
      autocomplete="off"
      class="d-none d-sm-flex mb-6"
      hide-details
      label="Library / ห้องสมุด"
      prepend-inner-icon="mdi-library"
      outlined
      v-model="name"
    />
    <v-select
      :items="categories"
      class="d-flex d-sm-none mb-6"
      hide-details
      label="Category / ประเภทหนังสือ"
      outlined
      prepend-inner-icon="mdi-shape"
      v-model="category"
    />
    <v-autocomplete
      :items="categories"
      autocomplete="off"
      class="d-none d-sm-flex mb-6"
      hide-details
      label="Category / ประเภทหนังสือ"
      outlined
      prepend-inner-icon="mdi-shape"
      v-model="category"
    />
    <v-text-field
      class="mb-6"
      hide-details
      label="Call Number / เลขเรียกหนังสือ"
      outlined
      prepend-inner-icon="mdi-pound-box"
      v-model="code"
    />
    <v-btn
      @click="code ? $router.push(name + '/' + category + '/' + code) : null"
      block
      color="primary"
      large
      >Locate / ค้นหา</v-btn
    >
  </div>
</template>

<script>
export default {
  data() {
    return {
      category: this.libraries[this.keys[0]].categories[0],
      categories: this.libraries[this.keys[0]].categories,
      code: "",
      name: this.libraries[this.keys[0]].name,
      names: this.keys.map(i => this.libraries[i].name)
    };
  },
  watch: {
    name(x) {
      this.keys.forEach(i => {
        if (x === this.libraries[i].name) {
          this.categories = this.libraries[i].categories;
          this.category = this.libraries[i].categories[0];
        }
      });
    }
  },
  created() {
    this.$gtag.event("home", {});
  },
  props: ["keys", "libraries"]
};
</script>
